import * as TYPES from "../types";

export const monitorData = (state = {}, action) => {
  switch (action.type) {
    case TYPES.UPDATE_MONITOR_DATA:
      return { ...state, ...action.monitorData };
    case TYPES.REPLACE_MONITOR_DATA:
      return {};
    default:
      return state;
  }
};
